import { render, staticRenderFns } from "./MoreScheme.vue?vue&type=template&id=710c2d0a&scoped=true"
var script = {}
import style0 from "./MoreScheme.vue?vue&type=style&index=0&id=710c2d0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c2d0a",
  null
  
)

export default component.exports